import { render, staticRenderFns } from "./DocumentoTipo.vue?vue&type=template&id=205f50c2"
import script from "./DocumentoTipo.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentoTipo.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports